// extracted by mini-css-extract-plugin
export default {"container":"toggle_container__v0-On","inner":"toggle_inner__A2qkG","button":"toggle_button__dRICT","img-container":"toggle_img-container__46QtP"};